export default {"src":"/_next/static/media/card-placeholder-light.f486176b.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};